<style lang="less" scoped>
.btn-container{
    position:fixed;
    width:670px;
    margin:0 auto;
    height:100px;
    line-height: 100px;
    text-align: center;
    font-size: 36px;
    color:#FF6AB7;
    bottom:50px;
    background:#333;
    left:40px;
    border-radius: 100px;;
 }
 .wrapper{
    padding:50px 30px;
    background:linear-gradient(180deg, #A2FBFF 0% ,  #fff 100%);
 }
 .img-container{
    width: 400px;
    height: 300px;
    margin:0 auto;
    img{
        width: 100%;
        height: 100%;
    }
 }
 .img-caption{
    margin-top: 50px;
    font-weight: 700;
    font-size: 30px;
    line-height: 1.5;
 }
.placholder{
    height:150px;
}
</style>
<template>

<div class="wrapper">
    <div class="img-container">
        <img src="../../assets/images/promotion/tt.png" alt="">
    </div>
    <p class="img-caption">
        Need funds instantly? TitanLoan is your trusted partner.
    </p>
    <p class="img-caption">
        With our seamless application process and rapid approvals, your financial dreams are just a tap away.
    </p>
    <p class="img-caption">
        Whether it's for business, education, or personal needs, TitanLoan is here to support you.
    </p>
    <div class="btn-container" @click="jump">Apply Now</div>
    <div class="placholder"></div>
</div>

</template>
<script>
import { useRouter } from 'vue-router'
export default {
    setup () {
        const router = useRouter()
        const jump = () => {
            router.push({
                "path":"/promotion/download"
            })
        }
        return {
            jump
        }
    }
} 
</script>